import {AiFillLinkedin, AiFillGithub} from "react-icons/ai";

const data = [
    {
        id: 1,
        link: "https://www.linkedin.com/in/oytun-ikiz/",
        icon: <AiFillLinkedin/>,
    },
    {id: 2, link: "https://github.com/MrChelizt", icon: <AiFillGithub/>},
];

export default data;
